import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

export const AdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }

  const token = auth.getDecodedToken();

  if (token.role !== UserRole.ADMIN) {
    return router.createUrlTree([auth.homeRoute()]);
  }

  return true;
};
